// frontend/components/UpgradePrompt.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Sparkles, Zap, FileText, Image as ImageIcon } from 'lucide-react';

const UpgradePrompt = ({ 
  isOpen, 
  onClose, 
  messageCount = 0, 
  limit = 3, 
  hoursUntilReset = 0 
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSignUp = () => {
    navigate('/signup');
    onClose();
  };

  const handleLogin = () => {
    navigate('/login');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-white dark:bg-bg-60 rounded-2xl shadow-2xl max-w-md w-full p-6 animate-slide-up">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-fg-50">
            Daily Limit Reached
          </h2>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-fg-60 hover:text-fg-50 hover:bg-bg-50 transition-colors"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        {/* Message */}
        <div className="mb-6">
          <p className="text-fg-60 mb-2">
            You've used all {limit} free messages for today.
          </p>
          <p className="text-sm text-fg-70 mb-2">
            You can use chat again after 24 hours.
          </p>
          {hoursUntilReset > 0 && (
            <p className="text-sm text-fg-70">
              Your limit will reset in {hoursUntilReset} {hoursUntilReset === 1 ? 'hour' : 'hours'}.
            </p>
          )}
        </div>

        {/* Benefits */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-fg-50 mb-3">
            Create an account to unlock:
          </h3>
          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm text-fg-60">
              <Sparkles size={16} className="text-ac-02 flex-shrink-0" />
              <span>Unlimited messages</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-fg-60">
              <Zap size={16} className="text-ac-02 flex-shrink-0" />
              <span>Access to advanced AI models</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-fg-60">
              <FileText size={16} className="text-ac-02 flex-shrink-0" />
              <span>File uploads and document processing</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-fg-60">
              <ImageIcon size={16} className="text-ac-02 flex-shrink-0" />
              <span>Image generation and editing</span>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-2">
          <button
            onClick={handleSignUp}
            className="w-full px-4 py-3 bg-ac-02 text-white dark:text-black/70 rounded-lg font-medium hover:bg-ac-01 transition-colors"
          >
            Create Free Account
          </button>
          <button
            onClick={handleLogin}
            className="w-full px-4 py-3 bg-bg-50 text-fg-50 rounded-lg font-medium hover:bg-bg-40 transition-colors"
          >
            Already have an account? Sign in
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradePrompt;

